import React, { useState } from 'react'
import ModalHandleModel from './ModalHandleModel'
import { cnFormHandle } from './../FormHandle'
import { IHandleModelData } from '../../../../../../common-code/interfaces/materials/IHandleModelData'
import { INewHandleModelData, initialModel } from './../defaultValues'
import { IHandleData } from '../../../../../../common-code/interfaces/materials/IHandleData'
import Edit from '../../../../components/icons/Edit'
import Trash from '../../../../components/icons/Trash'
import { validateHandleModel, createHandleModel } from './HandleModels'
import No from '../../../../components/icons/No'
import Yes from '../../../../components/icons/Yes'

interface IHandleDataProps {
    model: IHandleModelData
    index: number
    setNewHandle: (newHandleModel: IHandleData) => void
    newHandle: IHandleData
}

const HadleModel = ({
    model,
    index,
    setNewHandle,
    newHandle,
}: IHandleDataProps) => {
    const [modal, setModal] = React.useState<boolean>(false)
    const handleToggleModal = () => setModal((prev) => !prev)
    const [newHandleModel, setNewHandleModel] = useState<INewHandleModelData>(
        initialModel(model)
    )    
    const handleSubmit = () => {
        const error = validateHandleModel(newHandleModel, newHandle )
        if (error) {
            setNewHandleModel({ ...newHandleModel, error })
            return
        }
        const modelNew = createHandleModel(newHandleModel)
        setNewHandle({
            ...newHandle,
            models: newHandle.models.map((el, i) =>
                i === index ? modelNew : el
            ),
        })
        setModal(false)
    }
    const handleDeleteModel = () => {
        setNewHandle({
            ...newHandle,
            models: newHandle.models.filter((_, i) => i !== index),
        })
    }

    return (
        <div className={cnFormHandle('Children')}>
            <div className={cnFormHandle('Box-Model')}><span>3d модель:</span> {newHandleModel?.object3D ? <Yes/> : <No/> } </div>
            <span>Ширина: {model.width}</span>
            <span>Высота: {model.height}</span>
            <span>Глубина: {model.depth}</span>
            {model.type && <span>Тип: {model.type} </span>}
            <div className={cnFormHandle('Box-Btn')}>
                <Edit handleToggleModal={handleToggleModal} />
                <Trash handleDeleteValue={handleDeleteModel} />
            </div>
            <ModalHandleModel
                newHandle={newHandle}
                modal={modal}
                handleToggleModal={handleToggleModal}
                newHandleModel={newHandleModel}
                handleSubmit={handleSubmit}
                setNewHandleModel={setNewHandleModel}
                keyValue={`#editModel${index}`}
            />
        </div>
    )
}

export default HadleModel
